export const types = ['info', 'success', 'warning', 'error'];
